var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSelect(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M8.095 1.17285H3.905C2.085 1.17285 1 2.25785 1 4.07785V8.26285C1 10.0879 2.085 11.1729 3.905 11.1729H8.09C9.91 11.1729 10.995 10.0879 10.995 8.26785V4.07785C11 2.25785 9.915 1.17285 8.095 1.17285Z",
    fill: "#92ABFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.36984 8.31293C5.27484 8.31293 5.17984 8.27793 5.10484 8.20293C4.95984 8.05793 4.95984 7.81793 5.10484 7.67293L6.60484 6.17293L5.10484 4.67293C4.95984 4.52793 4.95984 4.28793 5.10484 4.14293C5.24984 3.99793 5.48984 3.99793 5.63484 4.14293L7.39984 5.90793C7.54484 6.05293 7.54484 6.29293 7.39984 6.43793L5.63484 8.20293C5.55984 8.27793 5.46484 8.31293 5.36984 8.31293Z",
    fill: "#92ABFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelect);
export default __webpack_public_path__ + "static/media/Select.b42cfcfbec1e40ad3122e30f1adacde6.svg";
export { ForwardRef as ReactComponent };